import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { SERVICE_URL, SERVICE_MEMBER_URL, SERVICE_PCP_URL } from '../../../../tokens';
import { MemberDetails } from 'src/app/shared/interfaces/search-result-object.interface';
//import { GoogleAnalyticsService } from 'src/app/shared/services/google-analytics.service';
import { tap } from 'rxjs/operators';
import { OidcClientService } from '@upmc-healthplan-npm/oidc-client';

@Injectable({
  providedIn: 'root'
})
export class LoginFormService {

  private defaultTPAClientIdentifier = environment.defaultTPAClientIdentifier
  constructor(private http: HttpClient, @Inject(SERVICE_URL) private serviceUrl: any,
    @Inject(SERVICE_PCP_URL) private servicePCPUrl: any,
    @Inject(SERVICE_MEMBER_URL) private serviceMemberUrl: string,
    //private googleAnalytics: GoogleAnalyticsService,
    private auth: OidcClientService) {
    this.serviceUrl = `${serviceUrl}MemberNetworks`;
    this.servicePCPUrl = `${servicePCPUrl}`;
    this.serviceMemberUrl = serviceMemberUrl;

  }

  getMemberNetwork(memberId: string, tpaClientIdentifier?: string): Observable<any> {
    // let verificationDate = new Date().getTime() > new Date('2025-02-01').getTime() ? new Date().toISOString().substr(0, 10) : "2025-03-01";
    const params = new HttpParams({
      fromObject: {
          'tpaClientIdentifier' : tpaClientIdentifier ? tpaClientIdentifier : this.defaultTPAClientIdentifier,
          'memberNumber' : memberId
          // 'networkChangeVerificationDate': verificationDate
      }
    });

    return this.http.get(this.serviceUrl, {params: params});
  }

  getPCPName(memberId: string): Observable<any> {
    const params = new HttpParams({
      fromObject: {
          'memberId' : memberId
      }
    });
    return this.http.get(this.servicePCPUrl, { params: params, headers: { useAuth: 'token'}});
  }
  getMemberDetails(memberId: string): Observable<MemberDetails> {
    return this.http.get<MemberDetails>(`${this.serviceMemberUrl}/${memberId}`, { headers: { useAuth: 'token'}})
    .pipe(tap(response => {
      if (!this.auth.getUser()) {
        if (response && response['eligibilities'] && response['eligibilities'].length > 0) {
          //this.googleAnalytics.pushMemberInformation(null, null, response['eligibilities'][0].planType);
        }
      }
    }));
  }
}